const INITIAL_STATE = {
    modalCreateMenuVisibility: false,
    modalTitle: '',
    modalVisibility: false
}

export const MODAl_REDUCER = 'MODAl_REDUCER';

export const modalReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case MODAl_REDUCER:
            return {...state, ...action.payload}
        default:
            return state
    }
}
